import MuiButton from '@mui/material/Button'

import CircularProgress from '@mui/material/CircularProgress'
import { styled } from '@mui/material/styles'
import React from 'react'

const Button = styled(MuiButton)(() => ({
  boxShadow: 'none',
}))

export default React.forwardRef(({ children, loading, ...props }, ref) => {
  const { startIcon, endIcon, sx } = props

  return (
    <Button
      ref={ref}
      variant="contained"
      size="small"
      {...props}
      sx={{ fontSize: 14, fontWeight: 'bold', ...sx }}
      startIcon={
        loading ? <CircularProgress color="inherit" size={18} sx={{ mr: 1 }} /> : startIcon
      }
      endIcon={endIcon}
    >
      {children}
    </Button>
  )
})
